import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
/**
 * Componente de texto truncado com tooltip
 * 
 * @param {Object} props
 * @param {string} props.value - Valor a ser exibido
 * @param {number} props.maxLength - Comprimento máximo antes de truncar
 * @param {string} props.className - Classe CSS adicional
 */

const TruncatedText = ({
  value,
  maxLength = 12,
  className
}) => {
  // Converter para string e verificar se é válido
  const stringValue = value ? String(value) : '';

  if (!stringValue || stringValue.length <= maxLength) {
    return <span className={className} title={stringValue}>{stringValue}</span>;
  }

  const truncatedText = stringValue.substring(0, maxLength) + '..';
  return <TooltipContainer className={className}>
      <TooltipText title={stringValue}>
        {truncatedText}
      </TooltipText>
    </TooltipContainer>;
};

TruncatedText.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  maxLength: PropTypes.number,
  className: PropTypes.string
}; // Estilos

const TooltipContainer = styled.span`
  display: inline-block;
  max-width: 100%;
`;
const TooltipText = styled.span`
  cursor: help;
  border-bottom: 1px dotted #ccc;
  
  &:hover {
    border-bottom-color: #666;
  }
`;
export default TruncatedText;
